<template>
  <b-form-select
    v-model="selected"
    :custom-label="labelUsuario"
    :select-size="rows"
    @input="onChange"
    :disabled="isDisabled"
  >
    <option v-for="option in options" :value="option" v-bind:key="option.value">
      {{ option && option.text }}
    </option>
    <option :value="null" disabled v-if="options.length == 0">{{ emptyLabel }}</option>
  </b-form-select>
</template>

<script>
export default {
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'filter', 'selectedBy', 'rows'],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', this.selected);
      if (this.selected == null) {
        this.$emit('selectChange', 'id_tipo_esporte', null);
        return;
      }
      this.$emit('selectChange', 'id_tipo_esporte', this.selected);
    },
    labelUsuario({ nome }) {
      return nome && `${nome}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.value === value);
      } else {
        this.selected = this.options.find((option) => option.value === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions(filterSelected) {
      this.isLoading = true;
      this.$atenaList
        .getTiposEsporte({
          filter: `${filterSelected ? filterSelected : ''}`,
          order: 'nome'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ value: null, text: this.$i18n.t(this.emptyLabel) }];
          }
          const dataDTO = res.data.map((esporte) => ({
            value: esporte.id,
            text: esporte.nome
          }));
          this.options = this.options.concat(dataDTO);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    changeErrors() {
      this.$refs.user.applyResult({
        errors: ['Erro ao Carregar Dados'], // array of string errors
        valid: false, // boolean state
        failedRules: {} // should be empty since this is a manual error.
      });
    }
  },
  created() {
    if (this.selectedBy && this.selectedBy !== null) {
      this.setOptions(this.selectedBy);
    } else {
      this.setOptions(null);
    }
  },
  mounted() {
    // this.changeErrors();
  },
  watch: {
    selectedBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
        this.onChange();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
